/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ChatMessageCursorType = {
    Before: 'before',
    After: 'after',
    Around: 'around'
} as const;
export type ChatMessageCursorType = typeof ChatMessageCursorType[keyof typeof ChatMessageCursorType];

